import './NuiTag.less';

import React, { FC } from 'react';
import clsx from 'clsx';
import i18n from '../../common/i18n';
import { NuiTagBgr, NuiTagBgrType, NuiTagSize, NuiTagType } from './types/NuiTagType';

const darkTextBgrs: Array<NuiTagBgrType> = [
    NuiTagBgr.gold,
    NuiTagBgr['pure-white'],
    NuiTagBgr['light-grey'],
    NuiTagBgr['orange-gradient']
];
const NuiTag: FC<NuiTagType> = ({
    size = NuiTagSize.md,
    bgr = NuiTagBgr.burgundy,
    otherClass,
    dataAtid = 'nui-tag',
    children
}) => (
    <span
        data-atid={dataAtid}
        className={clsx(
            otherClass,
            `nui-tag-${size}`,
            `bg-${bgr}`,
            'nui-tag italic br-radius-2 lh-1 f-condensed text-extra-bold flex-inline items-center',
            darkTextBgrs.includes(bgr) ? 'c-black' : 'c-white-black'
        )}
    >
        {children || i18n('nui.new')}
    </span>
);

export default NuiTag;
